import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bbfeb28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "quote-intent" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  id: "intent-whenGetSolar-heading",
  class: "h4 quote-intent__title"
}, " When do you intend to get solar panels? ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  id: "intent-customerPreference-heading",
  class: "h4 quote-intent__title"
}, " Why are you looking to get solar? ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  id: "intent-whoSuggested-heading",
  class: "h4 quote-intent__title"
}, " How did you hear about us? ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Continue", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon quote-intent__next-button--icon icon-arrow-right" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Combobox = _resolveComponent("Combobox")!
  const _component_InputField = _resolveComponent("InputField")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Combobox, {
      ref: "whenGetSolar-combobox",
      modelValue: _ctx.selectedWhenGetSolar,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedWhenGetSolar) = $event)),
      "input-id": "select-intent-whenGetSolar",
      role: "group",
      "aria-labelledby": "intent-whenGetSolar-heading",
      options: _ctx.whenGetSolarOptions,
      label: "Please select",
      class: "mb-7 quote-intent__when-select form-group__input-group"
    }, null, 8, ["modelValue", "options"]),
    _hoisted_3,
    _createVNode(_component_Combobox, {
      ref: "customerPreference-combobox",
      modelValue: _ctx.selectedCustomerPreference,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedCustomerPreference) = $event)),
      "input-id": "select-intent-customerPreference",
      role: "group",
      "aria-labelledby": "intent-customerPreference-heading",
      options: _ctx.customerPreferenceOptions,
      label: "Please select",
      class: "mb-7 quote-intent__why-select form-group__input-group"
    }, null, 8, ["modelValue", "options"]),
    _hoisted_4,
    _createVNode(_component_Combobox, {
      ref: "whoSuggested-combobox",
      modelValue: _ctx.selectedWhoSuggested,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedWhoSuggested) = $event)),
      "input-id": "select-intent-whoSuggested",
      role: "group",
      "aria-labelledby": "intent-whoSuggested-heading",
      options: _ctx.whoSuggestedOptions,
      label: "Please select",
      class: "mb-7 quote-intent__source-select form-group__input-group"
    }, null, 8, ["modelValue", "options"]),
    (_ctx.requiredFollowUpField === 'surveyorId')
      ? (_openBlock(), _createBlock(_component_InputField, {
          key: 0,
          modelValue: _ctx.surveyorId,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.surveyorId) = $event)),
          modelModifiers: { trim: true },
          class: "mb-7 quote-intent__surveyor-id-input form-group__input-group",
          name: "Surveyor ID Number",
          label: "Surveyor ID Number",
          maxlength: "4",
          "data-testid": "quote-intent-surveyor-id"
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.requiredFollowUpField === 'voucherCode')
      ? (_openBlock(), _createBlock(_component_InputField, {
          key: 1,
          modelValue: _ctx.voucherCode,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.voucherCode) = $event)),
          modelModifiers: { trim: true },
          class: "mb-7 quote-intent__voucher-code-input form-group__input-group",
          name: "Voucher Code",
          label: "Voucher Code",
          "data-testid": "quote-intent-voucher-code"
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.requiredFollowUpField === 'referralCode')
      ? (_openBlock(), _createBlock(_component_InputField, {
          key: 2,
          modelValue: _ctx.referralCode,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.referralCode) = $event)),
          modelModifiers: { trim: true },
          class: "mb-7 quote-intent__referral-code-input form-group__input-group",
          name: "Referral Code",
          label: "Please Enter Partner Code",
          "data-testid": "quote-intent-referral-code"
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.requiredFollowUpField === 'otherSuggested')
      ? (_openBlock(), _createBlock(_component_InputField, {
          key: 3,
          modelValue: _ctx.otherSuggested,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.otherSuggested) = $event)),
          modelModifiers: { trim: true },
          class: "mb-7 quote-intent__other-suggested-input form-group__input-group",
          name: "Other Suggested",
          label: "Please enter details",
          "data-testid": "quote-intent-other-suggested"
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_AppButton, {
      class: "quote-intent__next-button",
      "full-width": "",
      size: "large",
      disabled: !_ctx.canGoToNextStep,
      "data-testid": "quote-intent-continue",
      onClick: _ctx.next
    }, {
      default: _withCtx(() => [
        _hoisted_5,
        _hoisted_6
      ], undefined, true),
      _: 1
    }, 8, ["disabled", "onClick"])
  ]))
}